export const BOOK_COVER_WIDTH = 216;
export const BOOK_COVER_HEIGHT = 278;
export const SHELF_GAP = 90;

export type BookCoverProps = {
  id: number;
  html: string;
  routeParam: string;
  title: string;
  disabled?: boolean;
};
